import styled, { css } from 'styled-components'

interface CouponWrapperUiProps {
  htmlAttrId: string
}

const CouponWrapperUi = styled.div.attrs<CouponWrapperUiProps>(p => ({
  id: p.htmlAttrId,
}))<CouponWrapperUiProps>`
  padding: 10px;

  ${p => p.theme.phone} {
    padding: 5px;
  }
  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      padding: 5px;
    `}
`

export default CouponWrapperUi
